import React, { useMemo, useRef, useState } from 'react';
import { ColDef, ColumnState } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { GridContextWrapper } from 'src/components/common/gridWrapper/GridContextWrapper';
import Grid_Select from 'src/components/common/gridWrapper/Grid_Select';
import {
  aggridHeaderClass,
  pdaCellStyle,
} from 'src/components/common/common';
import usePDA1090_R01Store from "./usePDA1090_R01Store";
import { StockInfo } from "./PDA1090_R01Dto";

type StockInfoWithInserted = StockInfo & { inserted?: boolean };

/**
 * PDA1090_R01 창고별 재고 현황 테이블
 * AG-Grid 사용
 */
const PDA1090_R01Table = () => {
  const { stockList } = usePDA1090_R01Store();

  const gridRef = useRef<AgGridReact<StockInfoWithInserted>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);
  const [columnState, setColumnState] = useState<ColumnState[] | null>(null);

  const paddedGridData = useMemo(() => {
    const data: StockInfoWithInserted[] = [...stockList];
    return data;
  }, [stockList]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: 'LOT',
        field: 'lotNo',
        valueGetter: (params) => params.data?.lotNo || '-',
        cellStyle: (params) => ({
          textAlign: 'left',
          ...pdaCellStyle,
        }),
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 90,
      },
      {
        headerName: '창고',
        field: 'warehouseNm',
        valueGetter: (params) => params.data?.warehouseNm || '-',
        cellStyle: () => ({
          textAlign: 'left',
          ...pdaCellStyle,
        }),
        headerClass: aggridHeaderClass,
        flex: 2,
        minWidth: 90,
      },
      {
        headerName: '위치',
        field: 'locationCd',
        valueGetter: (params) => params.data?.locationCd || '-',
        cellStyle: () => ({
          textAlign: 'left',
          ...pdaCellStyle,
        }),
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 90,
      },
      // {
      //   headerName: '등급',
      //   field: 'itemStatus',
      //   valueGetter: (params) => params.data?.itemStatus || '-',
      //   cellStyle: () => ({
      //     textAlign: 'center',
      //     ...pdaCellStyle,
      //     justifyContent: 'center',
      //   }),
      //   headerClass: aggridHeaderClass,
      //   flex: 0.8,
      //   minWidth: 90,
      // },
      {
        headerName: '재고량',
        field: 'stockQty',
        valueGetter: (params) => {
          const qty = params.data?.stockQty;
          return qty !== undefined && qty !== null ? qty.toLocaleString() : '-';
        },
        cellStyle: () => ({
          textAlign: 'right',
          ...pdaCellStyle,
          justifyContent: 'flex-end',
        }),
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 80,
      },
    ] as ColDef<StockInfoWithInserted>[],
    []
  );

  // DetailTable은 품목 기준 나머지 자재 참고용. 조정 대상은 Info(스캔 LOT)만 사용하므로 행 선택 없음
  const initSelected = () => {};

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">

      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={initSelected}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1090_R01_Table_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<StockInfoWithInserted>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1090_R01_Table_ColumnState"
            setColumnState={setColumnState}
          />
        </div>
      </GridContextWrapper>

      
    </div>
  );
};

export default PDA1090_R01Table;
